var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6667 28.0223H24.5417C25.255 28.0223 25.8333 27.444 25.8333 26.7306V13.154L15.5 5.11698L5.16667 13.154V26.7306C5.16667 27.444 5.74497 28.0223 6.45834 28.0223H10.3333V16.3973C10.3333 15.6839 10.9116 15.1056 11.625 15.1056H19.375C20.0884 15.1056 20.6667 15.6839 20.6667 16.3973V28.0223ZM18.0833 28.0223V17.6889H12.9167V28.0223H18.0833ZM3.082 11.5027L14.707 2.46103C15.1734 2.09825 15.8266 2.09825 16.293 2.46103L27.918 11.5027C28.2326 11.7474 28.4167 12.1237 28.4167 12.5223V26.7306C28.4167 28.8707 26.6818 30.6056 24.5417 30.6056H6.45834C4.31823 30.6056 2.58334 28.8707 2.58334 26.7306V12.5223C2.58334 12.1237 2.76736 11.7474 3.082 11.5027Z",
    fill: "#2C3439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.05f4c1745ff8c489a73809a1aca6b11c.svg";
export { ForwardRef as ReactComponent };